import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import {
  slackInstallationQueryKey,
  type SlackInstallation,
  type SlackInstallationStatus,
} from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface SlackInstallationResponse {
  success: boolean;
  installation: SlackInstallation | null;
  is_owner: boolean;
}

export const useSlackInstallation = (
  workspaceId: number | null,
): UseQueryResult<SlackInstallationStatus> => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: slackInstallationQueryKey(workspaceId ?? 0),
    enabled: workspaceId !== null,
    queryFn: async (): Promise<SlackInstallationStatus> => {
      const res = await fetch(ENDPOINTS.slack.installation(workspaceId ?? 0), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      });
      const body: SlackInstallationResponse = await handleResponse(res);
      return { installation: body.installation, isOwner: body.is_owner };
    },
  });
};
